import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import {
  GridWrapperModule,
  TableLayoutModule,
} from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  DaterangeModule,
  LoaderModule,
  NfFormsModule,
  RadioModule,
} from '@northfork/ng-basics'
import { FindRulesPopoverComponent } from './find-rules-popover/find-rules-popover.component'
import { RuleAppliedToComponent } from './rule-applied-to/rule-applied-to.component'
import { RuleCodeComponent } from './rule-code/rule-code.component'
import { RulesGridComponent } from './rules-grid/rules-grid.component'
import { RulesPanelComponent } from './rules-panel.component'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    NgbModalModule,
    NgbTooltipModule,
    NgbNavModule,
    NfFormsModule,
    DaterangeModule,
    ResizeHandleModule,
    NgbAccordionModule,
    GenericComponentsModule,
    NgbPopoverModule,
    RadioModule,
    FormsModule,

    GridWrapperModule,
    LoaderModule,
    ButtonModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgSelectModule,
  ],
  declarations: [
    RulesPanelComponent,
    RuleCodeComponent,
    RuleAppliedToComponent,
    RulesGridComponent,
    FindRulesPopoverComponent,
  ],
  exports: [RulesPanelComponent],
})
export class RulesModule {}

export { RulesPanelComponent }
